<template>
  <v-row align="center" justify="center">
    <v-col cols="8">

      <h2>Workshop</h2>
      <ul>
       <li>
          <a href="  https://xaccnus.github.io/"
            >HACC@NUS Workshop Series 2020</a
          >
        </li>
      </ul>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({}),
};
</script>
